<div a-style display="flex" justify="space-between">
    <m-text [type]="gs.enums.texts.heading1" text="Emojis"></m-text>
    <div>
    </div>
    <!-- <img (click)="closeModal()" src="https://s3.ap-south-1.amazonaws.com/files.mesbro.com/icons/cross.svg" a-style w="1" h="1" align="right"> -->
</div>
<div a-style display="flex" flexWrap="wrap" mt="0.6">
</div>

<!-- position="absolute" left="65" top="47" -->